import { Fragment } from 'react';
import { useRouter } from 'next/router';
import { Col, Image,Row, Typography } from 'antd';

import messageC from 'src/components/Message';

import classes from './ShareItem.module.less';

const ShareItem = (props: any) => {
	const router = useRouter();
	const url = `${process.env.NEXT_PUBLIC_WEB_URL}${router.asPath?.split('?')[0]}`;
	const copyLink = () => {
		const cb = navigator.clipboard;

		cb.writeText(`${window.location.origin}${router.asPath?.split('?')[0]}`).then(() => {
			messageC('Copied');
		});
	};

	const sosmed = {
		social_media: [
			{
				icon: '/images/default/logoFbColor.svg',
				name: 'Facebook',
				deeplink: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
			},
			{
				icon: '/images/default/logoXColor.svg',
				name: 'X',
				deeplink: `https://twitter.com/intent/tweet?url=${url}`,
			},
			{
				icon: '/images/default/logoWaColor.svg',
				name: 'WhatsApp',
				deeplink: `https://api.whatsapp.com/send?text=${url}`,
			},
			{
				icon: '/images/default/logoCopy.svg',
				name: 'Salin Link',
				deeplink: '',
			},
		],
	};

	return (
		<Row className={`${classes['container-share']} ${props.className}`} style={{marginLeft: '-15px'}}>
			{sosmed.social_media?.map((item: any) => {
				return item.name !== 'Salin Link' ? (
					<Col xs={6}>
						<Fragment key={item.name}>
							<a
								href={item.deeplink}
								rel="nofollow noreferrer"
								id={'detail-artikel-' + item.name}
								target="_blank"
							>
								{item.icon && (
									<Image
										key={item.name}
										className={classes['socmed-icon']}
										width={50}
										height={50}
										src={item.icon}
										alt={item.name}
										preview={false}
										style={{ cursor: 'pointer' }}
										loading='lazy'
									/>
								)}
							</a>
							<Typography className={classes.nameSosmed}>{item.name}</Typography>
						</Fragment>
					</Col>
				) : (
					<Col xs={6}>
						<Fragment key={item.name}>
							<div onClick={copyLink} id="detail-artikel-CopyLink">
								{item.icon && (
									<Image
										key={item.name}
										className={classes['socmed-icon']}
										width={50}
										height={50}
										src={item.icon}
										alt={item.name}
										preview={false}
										style={{ cursor: 'pointer' }}
										loading='lazy'
									/>
								)}
								<Typography className={classes.nameSosmed}>{item.name}</Typography>
							</div>
						</Fragment>
					</Col>
				);
			})}
		</Row>
	);
};

export default ShareItem;
